export default {
  data() {
    return {
      isDownloading: false,
    }
  },
  methods: {
    isBM() {
      return (
        (this.$canAccess(['brand-admin', 'brand-employee', 'agency-client', 'agency', 'agency-employee']) &&
          !this.$is_PM &&
          !this.$is_GD) ||
        this.$isTopBrandAdmin()
      )
    },
    isTM() {
      return this.$canAccess(['traffic-manager']) && !this.$is_PM && !this.$is_GD
    },
    canSendToReview(creativeStatus) {
      const allowedFlightStatuses = ['in_progress']
      const allowedCreativeStatuses = ['new', 'revision']

      return (
        this.$SBCampaignStatusAccess?.(allowedFlightStatuses, this.flightStatus) &&
        this.$SBCampaignStatusAccess?.(allowedCreativeStatuses, creativeStatus) &&
        this.$is_GD
      )
    },
    canRequestRevisionOrApprove(creativeStatus) {
      const allowedCreativeStatuses = ['in_review']

      return this.$SBCampaignStatusAccess?.(allowedCreativeStatuses, creativeStatus) && this.isBM()
    },
    isInRequestRevision(creativeStatus) {
      const allowedCreativeStatuses = ['revision']

      return this.$SBCampaignStatusAccess?.(allowedCreativeStatuses, creativeStatus) && this.isBM()
    },
    canUploadCreative() {
      const allowedFlightStatuses = ['approved', 'in_progress']
      return this.$SBCampaignStatusAccess?.(allowedFlightStatuses, this.flightStatus) && this.$is_GD
    },
    canDeleteCreative(creativeStatus) {
      const allowedFlightStatuses = ['in_progress']
      const allowedCreativeStatuses = ['new']

      return (
        this.$SBCampaignStatusAccess?.(allowedFlightStatuses, this.flightStatus) &&
        this.$SBCampaignStatusAccess?.(allowedCreativeStatuses, creativeStatus) &&
        this.$is_GD
      )
    },
    canUploadReplaceAndDeleteFile(creativeStatus) {
      const allowedFlightStatuses = ['in_progress']
      const allowedCreativeStatuses = ['new', 'revision']

      return (
        this.$SBCampaignStatusAccess?.(allowedFlightStatuses, this.flightStatus) &&
        this.$SBCampaignStatusAccess?.(allowedCreativeStatuses, creativeStatus) &&
        this.$is_GD
      )
    },

    canDownload(creativeStatus) {
      const allowedCreativeStatuses = ['approved']

      return this.$SBCampaignStatusAccess?.(allowedCreativeStatuses, creativeStatus)
    },
    async downloadCreativeFile(creative) {
      if (this.isDownloading) return

      this.isDownloading = true
      try {
        const response = await this.$store.dispatch('socialBoostCampaign/downloadCreative', {
          creative_id: creative.id,
        })

        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const url = URL.createObjectURL(blob)

        const fallbackFilename = `creative_${creative.id}.zip`
        const disposition = response.headers['content-disposition']
        const match = disposition && disposition.match(/filename="?([^"]+)"?/)
        const filename = match?.[1] || fallbackFilename

        const link = document.createElement('a')
        link.href = url
        link.download = filename
        link.click()

        URL.revokeObjectURL(url)
      } catch (error) {
        this.$message?.error?.('Download failed.')
        console.error('Download error:', error)
      } finally {
        this.isDownloading = false
      }
    },
  },
}
